<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">HHG UAB Cost Calculator </legend>
      <p class="define-text-color-no-records">
        UAB shipment costs are based on a variety of factors. In some instances, the conversion between pounds (lbs) and kilograms (kg) is often necessary to get a more
        accurate cost estimate than what appears on the TMSS 2.0 “HHG Query Results” page.
        The “HHG UAB Cost Calculator” can assist with that conversion.
      </p>
    </div>
  </div>
  <form [formGroup]="hhgUabCalculatorForm">
    <fieldset class="usa-fieldset">
      @if (isError) {
        <div class="grid-row">
          <div class="usa-alert usa-alert--error usa-alert--slim">
            <div class="usa-alert__body">
              <p class="usa-alert__text">
                {{errorMessage}}
              </p>
            </div>
          </div>
        </div>
      }
      <div class="grid-row grid-gap  padding-bottom-105">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <div class="grid-row grid-gap">
            <legend class="usa-legend usa-legend--medium"> UAB Information</legend>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label class="usa-label" for="uabtype">UAB Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <select id="uabtype" class="maxw-full usa-select" formControlName="uabType">
                <option value='' selected disabled>Choose...</option>
                <option value='International'>International</option>
                <option value='Domestic'>Domestic - Alaska & Canada</option>
              </select>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="tender_id" class="usa-label">Gross UAB weight in lbs<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text"  placeholder="Enter Gross UAB weight in lbs" id="uab_weight" class="maxw-full usa-input" formControlName="uabWeight" type="number" min="0" />
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label for="tender_id" class="usa-label">UAB % offered by TSP (per "HHG Query Results" page) <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text"  placeholder='Enter UAB % offered by TSP (per "HHG Query Results" page)' id="uab_pct" class="maxw-full usa-input" formControlName="uabPct" type="number" min="0" />
            </div>
          </div>
        </div>
      </div>

      <div class="grid-row grid-gap define-scrolling-modal">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <div class="grid-row grid-gap">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-4">
              <legend class="usa-legend usa-legend--medium">UAB Pieces:</legend>
            </div>

          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <ng-container >
            @for (objs of hhgUabCalculatorForm.get('piecedimensions')['controls']; track objs; let i = $index) {
              <div formArrayName="piecedimensions">
                <ng-container [formGroupName]="i">
                  <div class="grid-row grid-gap">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                      <label for="origin_city_name" class="usa-label">Length</label>
                      <input type="text"  id="length" class="usa-input define-padding-location" formControlName="length" (focusout)="calculateChKg(i)"  type="number" min="0" />
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                      <label for="origin_state" class="usa-label">Width</label>
                      <input type="text"  id="width" class="usa-input define-padding-location" formControlName="width" (focusout)="calculateChKg(i)" type="number" min="0" />
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                      <label for="origin_zip" class="usa-label">Height</label>
                      <input type="text"  id="height" class="usa-input define-padding-location" formControlName="height" (focusout)="calculateChKg(i)" type="number" min="0" />
                    </div>
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
                      <label for="origin_zip" class="usa-label">Chargeable  Kg</label>
                      <input type="text" readonly id="chargeableKg" class="usa-input define-padding-location" formControlName="chargeableKg"/>
                    </div>
                    @if (i>0) {
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                        <button type="button" class="usa-button usa-button--secondary pin-bottom" (click)="removeSingleRow(i)">Delete</button>
                      </div>
                    }
                  </div>
                </ng-container>
              </div>
            }
          </ng-container>
          <div class="grid-row grid-gap padding-top-4">
            <div class="grid-offset-3 grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <button type="button" class="usa-button define-add-row-button"  (click)="addRows()">
                <svg class="usa-icon text-bold" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#add"></use>
                </svg> Rows
              </button>
            </div>
            <!-- <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            Total Chargeable Kg : {{ calculator ? (calculator.totalChgKg ? truncateNumber(calculator.totalChgKg) : '') : ''}}
            <div *ngIf="!this.isValidChargKg" class="define-text-secondary">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>Total Chargeable Kg is over 2000 kg.
            </div>
          </div> -->
        </div>
      </div>

    </div>
  </fieldset>
  <div class="margin-top-2 grid-row">
    <ul class="usa-button-group">
      <li class="usa-button-group__item">
        <button type="button" class="usa-button" (click)="getData()" [disabled]="(!this.hhgUabCalculatorForm.controls['uabType'].valid)||(!this.hhgUabCalculatorForm.controls['uabWeight'].valid)||(!this.hhgUabCalculatorForm.controls['uabPct'].valid)" >Calculate</button>
      </li>
      <li class="usa-button-group__item">
        <button type="button" class="usa-button usa-button--outline" (click)="resetForm()" >Reset Form</button>
      </li>
      @if (closeBtnName && closeBtnName.length>0) {
        <li class="usa-button-group__item">
          <button class="usa-button usa-button--secondary" type="button" (click)="close()">Close</button>
        </li>
      }

    </ul>
  </div>

  @if (isShowEstimation) {
    <div class="grid-row grid-gap">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--medium"> UAB Estimate</legend>
        <div class="grid-row grid-gap">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            <label class="usa-label define-text-heavy">Estimated Cost to Government : {{ costInfo?.billToGovt | currency }}</label>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            <label class="usa-label">Gross Kg per Gross UAB weight (lbs) entered : {{ costInfo ? truncateNumber(costInfo.grossKg) : '' }}</label>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            <label class="usa-label"> Chgbl Kg by Volume : {{ costInfo ? truncateWholeNumber(costInfo.chargeKg) : '' }}</label>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            <label class="usa-label">Billable Kg (the greater of the two above) : {{ costInfo ? truncateNumber(costInfo.billKg) : '' }}</label>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            <label class="usa-label">Price per Kg : {{ costInfo ? costInfo.perKg : '' }}</label>
          </div>
        </div>
      </div>
    </div>
  }

</form>
</div>
